import React from 'react';

export type BenchType = 'composition' | 'constant' | 'individual';

interface Props {
  value: BenchType;
  onChange: (value: BenchType) => void;
}

const OPTIONS: { key: BenchType; label: string }[] = [
  { key: 'composition', label: 'Composition' },
  { key: 'constant', label: 'Constant' },
  { key: 'individual', label: 'Individual' },
];

/** Small full-width segmented control for the benchmark type. Composition /
 *  Constant are local UI modes; Individual maps to allow_individual_benchmark —
 *  the parent translates the selection into the right state/dispatch. */
const BenchmarkTypeSelector: React.FC<Props> = ({ value, onChange }) => (
  <div className="bmv2-typesel">
    <div className="bmv2-segs bmv2-segs--full">
      {OPTIONS.map(option => (
        <button
          key={option.key}
          type="button"
          className={`bmv2-seg${value === option.key ? ' is-active' : ''}`}
          onClick={() => onChange(option.key)}
        >
          {option.label}
        </button>
      ))}
    </div>
  </div>
);

export default BenchmarkTypeSelector;
